import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { useEmployee, useEmployeeLoginData } from '~/data/employee';

import { ResetPasswordType, postRestPassword } from './data';

export type useEmployeeDataOutput = {
  onSubmit: () => void;
};

type PropsType = {
  onSubmitSuccess?: () => void;
};

export const useResetPassword = (props: PropsType): useEmployeeDataOutput => {
  const { onSubmitSuccess } = props;
  const { t } = useTranslation();

  const { employee } = useEmployee();
  const { employeeAdminLoginData: employeeLoginData } = useEmployeeLoginData();

  const { enqueueSnackbar } = useSnackbar();

  const handleFormSubmit = () => {
    const postData: ResetPasswordType = {
      fLoginUserEmail: employee.empWorkContact.fEmpEmailWork,
      fLoginUsername: employeeLoginData.fLoginUsername,
    };
    (async () => {
      try {
        const response = await postRestPassword(postData);
        if (response) {
          if (!!onSubmitSuccess) {
            onSubmitSuccess();
          }
          enqueueSnackbar(t('laPasswordResetOK'), {
            variant: 'success',
          });
        }
      } catch (error) {
        enqueueSnackbar(t('errorMsg'), {
          variant: 'error',
        });
      }
    })();
  };

  return {
    onSubmit: handleFormSubmit,
  };
};
